module.exports = __webpack_public_path__ + "img/bg-adv.2124202a.2124202a.png";